"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.default = (0, react_1.createContext)({
    isLoading: false,
    authHeader: '',
});
